import AnimateTop from 'components/AnimateTop';
import BaseSpinner from 'components/common/BaseSpinner';
import Footer from 'components/footer/Footer';
import { FooterOkBtn, FooterPressText } from 'components/footer/Footer.styled';
import StepLayout from 'components/layout/StepLayout';
import { UserFormContext } from 'components/UserForm';
import { memo, useCallback, useContext, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import {
  sendZapier,
  sendZapierDjango,
  updateStatusOfArea,
} from 'store/slices/form.slice';
import { nextStep, prevStep } from 'store/slices/global.slice';
import { StepFeedbackContent } from './StepFeedback.styled';

const StepFeedback = () => {
  const dispatch = useDispatch();
  const { shortForm } = useContext(UserFormContext);
  const { data } = useSelector((state) => state.global.resDjangoGoogleApi);
  const { loading } = useSelector((state) => state.form);
  const continueRef = useRef(null);


  useEffect(() => {
    if (continueRef.current) continueRef.current.focus();
  }, [continueRef]);

  const onSendEmail = useCallback(async () => {
    await dispatch(sendZapier());
    await dispatch(sendZapierDjango());
    await dispatch(updateStatusOfArea({ areaStatus: false }));
    await dispatch(nextStep({ step: !shortForm ? 9 : 7 }));
  }, [dispatch, shortForm]);
  console.log(data)
  return (
    <AnimateTop>
      {!loading ? (
        <>
          {data.distanceMiles < 25 && (
            <StepLayout title={data.msg} withoutStep>
              <StepFeedbackContent>
                
              </StepFeedbackContent>
              <Footer
                nextArrowClick={() =>
                  dispatch(nextStep({ step: !shortForm ? 5 : 3 }))
                }
                prevArrowClick={() => dispatch(prevStep({ feedback: true }))}
              >
                <FooterOkBtn
                    onClick={() =>
                      dispatch(nextStep({ step: !shortForm ? 5 : 3 }))
                    }
                    ref={continueRef}
                  >
                    Continue
                  </FooterOkBtn>
                  <FooterPressText>press Enter ↵</FooterPressText>
                
              </Footer>
            </StepLayout>
          )}
          {data.distanceMiles > 100 && (
            <StepLayout title={data.msg} withoutStep>
              <StepFeedbackContent>
                <br />
              </StepFeedbackContent>
              <Footer disableArrows>
                <FooterOkBtn
                  onClick={() =>
                    dispatch(nextStep({ step: !shortForm ? 4 : 2 }))
                  }
                >
                  Let me another address
                </FooterOkBtn>
                <FooterOkBtn onClick={onSendEmail}>
                  Please email me when you can service my area
                </FooterOkBtn>
              </Footer>
            </StepLayout>
          )}
          {data.distanceMiles < 100 && data.distanceMiles > 25 && (
            <StepLayout title={data.msg} withoutStep>
              <StepFeedbackContent>
              </StepFeedbackContent>
              <Footer
                nextArrowClick={() =>
                  dispatch(nextStep({ step: !shortForm ? 5 : 3 }))
                }
                prevArrowClick={() => dispatch(prevStep({ feedback: true }))}
              >
                <FooterOkBtn
                  onClick={() =>
                    dispatch(nextStep({ step: !shortForm ? 5 : 3 }))
                  }
                  ref={continueRef}
                >
                  Continue
                </FooterOkBtn>
                <FooterPressText>press Enter ↵</FooterPressText>
              </Footer>
            </StepLayout>
          )}
        </>
      ) : (
        <>
          <BaseSpinner />
        </>
      )}
    </AnimateTop>
  );
};

export default memo(StepFeedback);
